import { render, staticRenderFns } from "./Artisttalks.vue?vue&type=template&id=1b6f38ee"
import script from "./Artisttalks.vue?vue&type=script&lang=js"
export * from "./Artisttalks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports